import * as api from 'api/trackedAccountProviders'

export const RECONNECT_TRACKED_ACCOUNT_PROVIDER = 'RECONNECT_TRACKED_ACCOUNT_PROVIDER'

export const reconnectTrackedAccountProvider = (id) => ({
  type: RECONNECT_TRACKED_ACCOUNT_PROVIDER,
  payload: api.reconnect(id)
})
